<template>
  <div class="upgrade-overlay" :style="{ position: position, width, minHeight: height }">
    <lottie-player v-if="!onlyButton" autoplay loop mode="normal" src="https://assets9.lottiefiles.com/private_files/lf30_atznrcwb.json" :style="{width:lottieWidth}" class="upgrade-lottie"></lottie-player>
    <h3 v-if="!onlyButton">{{ $t("components.dashboard.content.cantAccess") }}</h3>
    <p v-if="!onlyButton">{{ $t("components.dashboard.content.cantAccessMsg") }}</p>
    <el-button :size="size" type="primary" round @click="goOrganisation" v-if="!onlyButton">{{ $t("components.dashboard.content.upgrade") }}</el-button>
    <el-button :size="size" type="primary" round @click="openUpgradeDialog" v-else>{{ buttonText }}</el-button>
  </div>
</template>

<script>
export default {
  props: {
    position: {
      type: String,
      default: "static"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "100%"
    },
    onlyButton: {
      type: Boolean,
      default: false
    },
    lottieWidth: {
      type: String,
      default: "300px"
    },
    size: {
      type: String,
      default: "medium"
    },
    buttonText: {
      type: String,
      default: function() {
        this.$t("components.dashboard.content.upgrade");
      }
    },
    organisationID: {
      type: String,
      default: null
    }
  },
  methods: {
    goOrganisation() {
      var path = ``;
      if (this.organisationID != null) {
        path = `/organisation/${this.organisationID}/billing`;
        this.$router.push(path);
      } else {
        path = `/organisation/${this.event.organizationID}/billing`;
        window.open(path, "_self");
      }
    }
  },
  beforeMount() {
    // if (this.buttonText == null) {
    //   this.buttonText = this.$t("components.dashboard.content.upgrade");
    // }
  },
  computed: {
    event() {
      return this.$store.getters.currentEvent;
    }
  }
};
</script>

<style lang="less" scoped>
.upgrade-overlay {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.34);
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;
  backdrop-filter: blur(5px);
  border-radius: 8px;
  overflow: hidden;
  .upgrade-lottie {
    margin-bottom: 2rem;
  }
  h3 {
    color: #292f3b;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 6px !important;
    line-height: normal;
    text-align:center;
  }

  p {
    color: #505763;
    font-size: 13px;
    font-weight: 400;
    text-align: center;
  }

  button {
    margin-top: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upgrade/UpgradeOverlay.vue